import { AppShell, Burger, Button, Group, Menu, Text } from '@mantine/core';
import { IconLogout, IconPassword, IconUser } from '@tabler/icons-react';
import { matchPath, useNavigate } from 'react-router-dom';
import { OrganisationSelector } from '../../components/OrganisationSelector';
import { BRISTEC_ADMIN } from '../../const/constants';
import { useAuth } from '../../hooks/useAuth';
import { useModal } from '../../hooks/useModal';
import { defaultIconStyle } from '../../theme/styling/iconStyling';
import { ResetPasswordModal } from '../organisation-accounts/components/ResetPasswordModal';
import { SidebarPaths } from './SidebarPaths';
import { mutateSignOut } from './api/signOutMutation';

interface NavbarProps {
	isOpenDesktop: boolean;
	isOpenMobile: boolean;
	toggleNavbarDesktop: () => void;
	toggleNavbarMobile: () => void;
}

export function Navbar({
	isOpenDesktop,
	isOpenMobile,
	toggleNavbarDesktop,
	toggleNavbarMobile,
}: NavbarProps) {
	const auth = useAuth();
	const signOutMutation = mutateSignOut();
	const match = matchPath('/:organisation/*', window.location.pathname);

	const organisation = match?.params?.organisation;

	const navigation = useNavigate();

	const signOut = async () => {
		await signOutMutation.mutateAsync();

		auth.signOut();

		navigation('/login');
	};

	const passwordModal = useModal();

	return (
		<>
			<AppShell.Header>
				<Group h="100%" px={'lg'} justify={'space-between'}>
					<>
						<Group>
							<Burger
								opened={isOpenMobile}
								onClick={toggleNavbarMobile}
								hiddenFrom={'sm'}
								size={'sm'}
							/>
							<Burger
								opened={isOpenDesktop}
								onClick={toggleNavbarDesktop}
								visibleFrom={'sm'}
								size={'sm'}
							/>
							<Text size={'xl'} fw={500}>
								MedEpos
							</Text>
						</Group>
						<ResetPasswordModal
							close={passwordModal.close}
							opened={passwordModal.isOpen}
							organisation={organisation}
							// Empty account ID will use of logged in user
						/>
						<Group>
							{auth.getRole() === BRISTEC_ADMIN && <OrganisationSelector />}
							<Menu position="bottom-end">
								<Menu.Target>
									<Button
										variant={'subtle'}
										color="medepos.0"
										leftSection={<IconUser {...defaultIconStyle} />}
									>
										Account
									</Button>
								</Menu.Target>
								<Menu.Dropdown>
									<Menu.Item
										leftSection={<IconPassword {...defaultIconStyle} />}
										onClick={() => passwordModal.open()}
									>
										Reset Password
									</Menu.Item>
									<Menu.Item
										leftSection={<IconLogout {...defaultIconStyle} />}
										c={'red'}
										onClick={() => signOut()}
									>
										Sign Out
									</Menu.Item>
								</Menu.Dropdown>
							</Menu>
						</Group>
					</>
				</Group>
			</AppShell.Header>
			<AppShell.Navbar bg={'medepos.0'} pt={'md'}>
				<SidebarPaths />
			</AppShell.Navbar>
		</>
	);
}
